/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tooltip_CalendarInputs */

const en_tooltip_calendar = /** @type {(inputs: Tooltip_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provide a link to your Calendly, Cal.com, or Acuity scheduling page. Buyers will be redirected here immediately after checkout.`)
};

const id_tooltip_calendar = /** @type {(inputs: Tooltip_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sediakan tautan ke halaman penjadwalan Calendly, Cal.com, atau Acuity Anda. Pembeli akan diarahkan ke sini segera setelah checkout.`)
};

/** @type {(inputs: Tooltip_CalendarInputs) => LocalizedString} */
const es_tooltip_calendar = en_tooltip_calendar;

/** @type {(inputs: Tooltip_CalendarInputs) => LocalizedString} */
const fr_tooltip_calendar = en_tooltip_calendar;

/** @type {(inputs: Tooltip_CalendarInputs) => LocalizedString} */
const de_tooltip_calendar = en_tooltip_calendar;

/** @type {(inputs: Tooltip_CalendarInputs) => LocalizedString} */
const ja_tooltip_calendar = en_tooltip_calendar;

/** @type {(inputs: Tooltip_CalendarInputs) => LocalizedString} */
const zh_tooltip_calendar = en_tooltip_calendar;

/** @type {(inputs: Tooltip_CalendarInputs) => LocalizedString} */
const ar_tooltip_calendar = en_tooltip_calendar;

/** @type {(inputs: Tooltip_CalendarInputs) => LocalizedString} */
const it_tooltip_calendar = en_tooltip_calendar;

/** @type {(inputs: Tooltip_CalendarInputs) => LocalizedString} */
const ru_tooltip_calendar = en_tooltip_calendar;

/** @type {(inputs: Tooltip_CalendarInputs) => LocalizedString} */
const pt_tooltip_calendar = en_tooltip_calendar;

/** @type {(inputs: Tooltip_CalendarInputs) => LocalizedString} */
const ko_tooltip_calendar = en_tooltip_calendar;

/**
* | output |
* | --- |
* | "Provide a link to your Calendly, Cal.com, or Acuity scheduling page. Buyers will be redirected here immediately after checkout." |
*
* @param {Tooltip_CalendarInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tooltip_calendar = /** @type {((inputs?: Tooltip_CalendarInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tooltip_CalendarInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tooltip_calendar(inputs)
	if (locale === "es") return es_tooltip_calendar(inputs)
	if (locale === "fr") return fr_tooltip_calendar(inputs)
	if (locale === "de") return de_tooltip_calendar(inputs)
	if (locale === "ja") return ja_tooltip_calendar(inputs)
	if (locale === "zh") return zh_tooltip_calendar(inputs)
	if (locale === "ar") return ar_tooltip_calendar(inputs)
	if (locale === "id") return id_tooltip_calendar(inputs)
	if (locale === "it") return it_tooltip_calendar(inputs)
	if (locale === "ru") return ru_tooltip_calendar(inputs)
	if (locale === "pt") return pt_tooltip_calendar(inputs)
	return ko_tooltip_calendar(inputs)
});